import { type ExcalidrawFontFaceDescriptor } from "../Fonts";

import CaveatRegular from "./Caveat-Regular.woff2";

export const CaveatFontFaces: ExcalidrawFontFaceDescriptor[] = [
  {
    uri: CaveatRegular,
  },
];
